import React from 'react';
import { useOnboarding } from './OnboardingProvider';

// Shown inline in SearchPage for existing users on first post-update visit.
// Lets them try simple mode, re-run the wizard, or just dismiss.
export default function WhatsNewBanner() {
  const { dismissWhatsNew } = useOnboarding();

  return (
    <div style={{
      margin: '0 0 12px 0',
      padding: '12px 14px',
      borderRadius: '12px',
      background: 'color-mix(in srgb, #5c7cfa 10%, var(--bg-card, #fff) 90%)',
      border: '1px solid color-mix(in srgb, #5c7cfa 35%, var(--border-color, #ccc) 65%)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '8px',
      fontSize: '0.88rem',
    }}>
      <span style={{ flex: '1 1 auto', fontWeight: 600, minWidth: '180px' }}>
        ✨ New: Simple &amp; Full modes — set up how much you want to see
      </span>
      <div style={{ display: 'flex', gap: '7px', flexWrap: 'wrap' }}>
        <button
          onClick={() => dismissWhatsNew('simple')}
          style={{
            padding: '5px 12px', borderRadius: '8px', border: 'none',
            background: '#16a34a', color: '#fff',
            fontSize: '0.82rem', fontWeight: 700, cursor: 'pointer',
          }}
        >
          Try Simple
        </button>
        <button
          onClick={() => dismissWhatsNew('rerun')}
          style={{
            padding: '5px 12px', borderRadius: '8px',
            border: '1px solid color-mix(in srgb, #5c7cfa 50%, var(--border-color) 50%)',
            background: 'transparent', color: 'var(--text-primary)',
            fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Run Setup Wizard
        </button>
        <button
          onClick={() => dismissWhatsNew('dismiss')}
          style={{
            padding: '5px 10px', borderRadius: '8px',
            border: '1px solid var(--border-color, #ccc)',
            background: 'transparent', color: 'var(--text-muted)',
            fontSize: '0.82rem', cursor: 'pointer',
          }}
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
